import {Modal} from 'antd';
import React from 'react';
import iconConfirm from './images/icon_confirm.png';
import iconClose2 from './images/icon_close2.png';

const ModalCustom = props => {
    return <Modal {...props}>{props.children}</Modal>;
};
// eslint-disable-next-line func-names
ModalCustom.confirm = function (options) {
    Modal.confirm({
        centered: true,
        okText: '确认',
        cancelText: '取消',
        className: `huibo-antd-method-modal ${options?.titleCentered ? 'huibo-antd-method-modal-title-centered' : ''}`,
        width: 420,
        closable: true,
        icon: <span className="anticon anticon-exclamation-circle"><img src={iconConfirm} className="method-icon" /></span>,
        closeIcon: <img src={iconClose2} className="close" />,
        ...options
    });
};

ModalCustom.info = function (options) {
    Modal.info(options);
};

ModalCustom.success = function (options) {
    Modal.success(options);
};
ModalCustom.error = function (options) {
    Modal.error(options);
};
ModalCustom.warning = function (options) {
    Modal.warning(options);
};
export default ModalCustom;
